import { render, staticRenderFns } from "./EntriesByGroup.vue?vue&type=template&id=de27b72c"
import script from "./EntriesByGroup.vue?vue&type=script&lang=js"
export * from "./EntriesByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports